import { useStaticQuery, graphql } from "gatsby"

export const useCategories = () => {
  const data = useStaticQuery(
    graphql`
    query CategoriesQuery {
      allPrismicCategory(sort: {order: ASC, fields: data___navbarorder}) {
        edges {
          node {
            prismicId
            uid
            data {
              name
              navbarorder
            }
          }
        }
      }
    }
    `
  )
  return data.allPrismicCategory.edges
}